import { render, staticRenderFns } from "./PublicImage.vue?vue&type=template&id=bf62e712&scoped=true"
import script from "./PublicImage.vue?vue&type=script&lang=js"
export * from "./PublicImage.vue?vue&type=script&lang=js"
import style0 from "./PublicImage.vue?vue&type=style&index=0&id=bf62e712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf62e712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VTextField})
